import React from "react";

const MarkChatReadIcon = ({ className, ...rest }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m4.5 11.69 6.97-6.97 1.06 1.06-7.5 7.5a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06zm4.5 0 6.97-6.97 1.06 1.06-7.5 7.5a.75.75 0 0 1-1.06 0l-1.125-1.124 1.06-1.061z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default MarkChatReadIcon;
